var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative"},[_c(_setup.MapView,{attrs:{"options":{ disableDefaultUI: true }},scopedSlots:_vm._u([{key:"default",fn:function({ ready }){return [(ready)?[_vm._l((_setup.trip.waypoints),function(waypoint,index){return _c(_setup.MapDefaultMarker,{key:waypoint._id,attrs:{"options":{
            position: {
              lat: waypoint.location.latitude,
              lng: waypoint.location.longitude,
            },
          },"label":(index + 1).toString()}})}),_vm._v(" "),_c(_setup.MapRoutes)]:_vm._e()]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }